import { membersBaseURL } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params) => window.axios.post(url, params, { baseURL });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = url => window.axios.get(url, { baseURL });

export default {
  get(context, params) {
    return new Promise((resolve, reject) => {
      const commit = params.commit ?? true;
      delete params.commit;

      const queryString = new URLSearchParams(params).toString();
      return _get(
        `/courses/modules/list/${params.product_id}?${queryString}&limit=50`
      )
        .then(({ data: { results, count, next, previous } }) => {
          if (commit) {
            context.commit("setModules", results);
            context.commit("setPagination", { count, next, previous });
          }
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      _get(`/courses/modules/${id}`)
        .then(({ data }) => {
          context.commit("setModule", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      _post("/courses/modules", params)
        .then(resolve)
        .catch(reject);
    });
  },
  duplicate(context, id) {
    return new Promise((resolve, reject) => {
      _post(`/courses/duplicate/module/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  clone(context, params) {
    return new Promise((resolve, reject) => {
      _post(`/courses/duplicate/module-to`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/courses/modules/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  postSub(context, params) {
    return new Promise((resolve, reject) => {
      _post("/courses/submodules", params)
        .then(resolve)
        .catch(reject);
    });
  },
  putSub(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/courses/submodules/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  reorder(context, modules) {
    return new Promise((resolve, reject) => {
      _put(`/courses/modules/reorder`, { modules })
        .then(resolve)
        .catch(reject);
    });
  },
  reorderItems(context, items) {
    return new Promise((resolve, reject) => {
      _put(`/courses/modules/items/reorder`, { items })
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/courses/modules/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteSub(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/courses/submodules/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
